(function () {
    'use strict';

    angular
        .module('ib-header-popover-module')
        .controller('ibHeaderPopoverController', ibHeaderPopoverController);

    ibHeaderPopoverController.$inject = ['$scope'];

    function ibHeaderPopoverController($scope) {
        var vm = this;
        vm.isOpen = false;

        vm.close = function () {
            vm.isOpen = false;
        }

        //Event open - Emit to the directive when popover opens
        vm.open = function () {
            $scope.$emit('assignEvent');
        }

        //Function to change state isOpen
        vm.isFocusIn = function (param) {
            $scope.$apply(function () {
                vm.isOpen = param;
            });
        }

        //Close or Open State - Directive message
        $scope.$on('isFocusIn', function (event, param) {
            vm.isFocusIn(param);
        });

    }
})();